import { z } from "zod";

export const registerSchema = z
  .object({
    firstname: z.string().min(1, "firstname is Required"),
    lastname: z.string().min(1, "lastname is Required"),
    email: z
      .string()
      .min(1, "email is Required")
      .email({
        message: "Email is" + " Required",
      }),
    password: z.string().min(5, "password must be at least 10 characters"),
    confirmPassword: z.string().min(1, "Confirm Password is Required"),
    role: z.string().min(1, "role is Required"),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords must match",
    path: ["confirmPassword"],
  });

export const loginSchema = z.object({
  email: z
    .string()
    .min(1, "Email is Required")
    .email({ message: "Email is Required" }),
  password: z.string().min(1, "Password is Required"),
});

export type TRegisterSchema = z.infer<typeof registerSchema>;
export type TRegisterSchemaWithoutConfirmPassword = Omit<
  TRegisterSchema,
  "confirmPassword"
>;

export type TLoginSchema = z.infer<typeof loginSchema>;
